export const setQueryCity = (abc) => ({
    type:'SET',
    payload: abc,
});


export const setData = (xyz) => ({
    type: "SET",
    payload: xyz,
});
